import styled from "styled-components";

export const Filters = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const FilterOptions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  @media (max-width: 575px) {
    flex-direction: column;
  }
`;

export const FilterItem = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 0;

  span,
  p,
  a {
    font-size: 13px;
    line-height: 19px;
    letter-spacing: 0.01em;
  }

  > span {
    color: ${props => props.theme.colors[27]};
    margin-right: 5px;
  }

  > div > div {
    padding: 0 20px 0 3px;
  }

  input {
    padding: 0;
    margin: 0;
    background-color: transparent;
    border: none;
    font-size: 13px;
    line-height: 19px;
    color: ${props => props.theme.colors[19]};
  }

  @media (max-width: 575px) {
    flex-direction: column;
    margin-bottom: 10px;
  }
`;

export const FilterSwitch = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FilterSpacer = styled.div`
  width: 10px;
`;

export const RangeFilter = styled.div`
  display: flex;

  @media (max-width: 575px) {
    flex-direction: column;
    justify-content: space-between;
    margin-bottomn: 10px;
  }
`;
